module.exports = __webpack_public_path__ + "assets/search.8b49baae.svg";